import { PatsnapCopilotService } from './patsnap-copilot-service.interface';
import type { PatsnapCopilotUsage } from './patsnap-copilot-service.interface';
import { injectService } from '@patsnap/tahiti-core';

export function wujieOptions(config: {
    url: string;
    patsnapCopilotUsage?: PatsnapCopilotUsage;
    service?: PatsnapCopilotService;
 }): {
    name: string,
    alive: boolean,
    url: string,
    props: {
        patsnapCopilotService: () => PatsnapCopilotService,
    },
} {
    return {
        name: 'analytics:patsnap-copilot',
        alive: true,
        url: config.url,
        props: {
            patsnapCopilotService: () => {
                let service = config && config.service;
                if (!service) {
                    service = injectService<PatsnapCopilotService>(PatsnapCopilotService);
                }
                /**
                 * 有些场景下，用户可能需要使用自己传入的 patsnapCopilotUsage, 如果用户传入了 patsnapCopilotUsage，则将它设置到 service 上,
                 * 否则使用 service 的 patsnapCopilotUsage默认值
                 */
                if (service && config.patsnapCopilotUsage) {
                    service.patsnapCopilotUsage = config.patsnapCopilotUsage;
                }
                return service;
            },
        }
    }
}
